import {Companies} from "./models.js";

function NewsItem(title, content, year, monthCount, priority, companyName = null) {

    // Boolean
    const headline = false;

    // Foreign keys
    const companyId = null;

    return {
        title,
        content,
        year,
        monthCount,
        priority,
        companyName,
        headline,
        companyId,
    };
}

function getNewsItemCompany(newsItem) {
    return Companies.find({'$loki': newsItem.companyId})[0];
}

export { NewsItem, getNewsItemCompany}
